import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=15c7b200&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=15c7b200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c7b200",
  null
  
)

export default component.exports